export const SYSTEM_DEFAULT_HOUR_RATE = 700;
